import {
  IndexOutOfBoundsException_init_$Create$2w5dv25cjssuw as IndexOutOfBoundsException_init_$Create$,
  IllegalArgumentException_init_$Create$3ewkh27kzt8z8 as IllegalArgumentException_init_$Create$,
  subtract2orl8z9upxd9l as subtract,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  toShort36kaw0zjdq3ex as toShort,
  add2suhfggl4zvkk as add,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
  StringBuilder_init_$Create$2ujvu6cqvzuyn as StringBuilder_init_$Create$,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  IllegalStateException_init_$Create$2w9444nebyjns as IllegalStateException_init_$Create$,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  arrayCopytctsywo3h7gj as arrayCopy,
  toByte4i43936u611k as toByte,
  IllegalArgumentException_init_$Create$3vjwoodhlckbo as IllegalArgumentException_init_$Create$_0,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  multiply2k9eolhnz1bjv as multiply,
  charCodeAt1yspne1d8erbm as charCodeAt,
  Char__toInt_impl_vasixd1agw9q2fuvclj as Char__toInt_impl_vasixd,
  charArray2ujmm1qusno00 as charArray,
  numberToChar93r9buh19yek as numberToChar,
  concatToString3cxf0c1gqonpo as concatToString,
  Exception_init_$Init$7nmtst2tre47 as Exception_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  Exception_init_$Init$33ewqhqmjrfx6 as Exception_init_$Init$_0,
  Exception_init_$Init$393utbttlf2x4 as Exception_init_$Init$_1,
  Exceptiondt2hlxn7j7vw as Exception,
} from './kotlin-kotlin-stdlib.mjs';
import { UnsafeByteStringOperations_instance24iw7lp31iicx as UnsafeByteStringOperations_instance } from './kotlinx-io-kotlinx-io-bytestring.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForInterface(Source, 'Source', VOID, VOID, [AutoCloseable]);
function write$default(source, startIndex, endIndex, $super) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? source.length : endIndex;
  var tmp;
  if ($super === VOID) {
    this.e1v(source, startIndex, endIndex);
    tmp = Unit_instance;
  } else {
    tmp = $super.e1v.call(this, source, startIndex, endIndex);
  }
  return tmp;
}
initMetadataForInterface(Sink, 'Sink', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Buffer, 'Buffer', Buffer, VOID, [Source, Sink]);
initMetadataForClass(PeekSource, 'PeekSource', VOID, VOID, [AutoCloseable]);
initMetadataForClass(RealSource, 'RealSource', VOID, VOID, [Source]);
initMetadataForCompanion(Companion);
initMetadataForClass(Segment, 'Segment');
initMetadataForClass(SegmentCopyTracker, 'SegmentCopyTracker');
initMetadataForObject(AlwaysSharedCopyTracker, 'AlwaysSharedCopyTracker', VOID, SegmentCopyTracker);
initMetadataForObject(UnsafeBufferOperations, 'UnsafeBufferOperations');
initMetadataForClass(SegmentReadContextImpl$1);
initMetadataForClass(SegmentWriteContextImpl$1);
initMetadataForClass(BufferIterationContextImpl$1);
initMetadataForClass(IOException, 'IOException', IOException_init_$Create$, Exception);
initMetadataForClass(EOFException, 'EOFException', EOFException_init_$Create$, IOException);
initMetadataForObject(SegmentPool, 'SegmentPool');
//endregion
function get_HEX_DIGIT_CHARS() {
  _init_properties__Util_kt__g8tcl9();
  return HEX_DIGIT_CHARS;
}
var HEX_DIGIT_CHARS;
function checkBounds(size, startIndex, endIndex) {
  _init_properties__Util_kt__g8tcl9();
  if (startIndex < 0n || endIndex > size) {
    throw IndexOutOfBoundsException_init_$Create$('startIndex (' + startIndex.toString() + ') and endIndex (' + endIndex.toString() + ') are not within the range [0..size(' + size.toString() + '))');
  }
  if (startIndex > endIndex) {
    throw IllegalArgumentException_init_$Create$('startIndex (' + startIndex.toString() + ') > endIndex (' + endIndex.toString() + ')');
  }
}
function checkOffsetAndCount(size, offset, byteCount) {
  _init_properties__Util_kt__g8tcl9();
  if (offset < 0n || offset > size || subtract(size, offset) < byteCount || byteCount < 0n) {
    throw IllegalArgumentException_init_$Create$('offset (' + offset.toString() + ') and byteCount (' + byteCount.toString() + ') are not within the range [0..size(' + size.toString() + '))');
  }
}
var properties_initialized__Util_kt_67kc5b;
function _init_properties__Util_kt__g8tcl9() {
  if (!properties_initialized__Util_kt_67kc5b) {
    properties_initialized__Util_kt_67kc5b = true;
    // Inline function 'kotlin.charArrayOf' call
    HEX_DIGIT_CHARS = charArrayOf([_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(49), _Char___init__impl__6a9atx(50), _Char___init__impl__6a9atx(51), _Char___init__impl__6a9atx(52), _Char___init__impl__6a9atx(53), _Char___init__impl__6a9atx(54), _Char___init__impl__6a9atx(55), _Char___init__impl__6a9atx(56), _Char___init__impl__6a9atx(57), _Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(98), _Char___init__impl__6a9atx(99), _Char___init__impl__6a9atx(100), _Char___init__impl__6a9atx(101), _Char___init__impl__6a9atx(102)]);
  }
}
function throwEof($this, byteCount) {
  throw EOFException_init_$Create$_0("Buffer doesn't contain required number of bytes (size: " + $this.o().toString() + ', required: ' + byteCount.toString() + ')');
}
function Buffer() {
  this.r1t_1 = null;
  this.s1t_1 = null;
  this.t1t_1 = 0n;
}
protoOf(Buffer).o = function () {
  return this.t1t_1;
};
protoOf(Buffer).u1t = function () {
  return this;
};
protoOf(Buffer).v1t = function () {
  return this.o() === 0n;
};
protoOf(Buffer).w1t = function (byteCount) {
  // Inline function 'kotlin.require' call
  if (!(byteCount >= 0n)) {
    var message = 'byteCount: ' + byteCount.toString();
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (this.o() < byteCount) {
    throw EOFException_init_$Create$_0("Buffer doesn't contain required number of bytes (size: " + this.o().toString() + ', required: ' + byteCount.toString() + ')');
  }
};
protoOf(Buffer).x1t = function (byteCount) {
  // Inline function 'kotlin.require' call
  if (!(byteCount >= 0n)) {
    var message = 'byteCount: ' + byteCount.toString() + ' < 0';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return this.o() >= byteCount;
};
protoOf(Buffer).y1t = function () {
  var tmp0_elvis_lhs = this.r1t_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwEof(this, 1n);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var segment = tmp;
  var segmentSize = segment.o();
  if (segmentSize === 0) {
    this.g1u();
    return this.y1t();
  }
  var v = segment.h1u();
  this.t1t_1 = subtract(this.t1t_1, 1n);
  if (segmentSize === 1) {
    this.g1u();
  }
  return v;
};
protoOf(Buffer).i1u = function () {
  var tmp0_elvis_lhs = this.r1t_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwEof(this, 2n);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var segment = tmp;
  var segmentSize = segment.o();
  if (segmentSize < 2) {
    this.w1t(2n);
    if (segmentSize === 0) {
      this.g1u();
      return this.i1u();
    }
    // Inline function 'kotlinx.io.and' call
    var tmp_0 = (this.y1t() & 255) << 8;
    // Inline function 'kotlinx.io.and' call
    var tmp$ret$1 = this.y1t() & 255;
    return toShort(tmp_0 | tmp$ret$1);
  }
  var v = segment.j1u();
  this.t1t_1 = subtract(this.t1t_1, 2n);
  if (segmentSize === 2) {
    this.g1u();
  }
  return v;
};
protoOf(Buffer).k1u = function () {
  return Unit_instance;
};
protoOf(Buffer).l1u = function (out, startIndex, endIndex) {
  checkBounds(this.o(), startIndex, endIndex);
  if (startIndex === endIndex)
    return Unit_instance;
  var currentOffset = startIndex;
  var remainingByteCount = subtract(endIndex, startIndex);
  out.t1t_1 = add(out.t1t_1, remainingByteCount);
  var s = this.r1t_1;
  while (currentOffset >= fromInt(ensureNotNull(s).b1u_1 - s.a1u_1 | 0)) {
    currentOffset = subtract(currentOffset, fromInt(s.b1u_1 - s.a1u_1 | 0));
    s = s.e1u_1;
  }
  while (remainingByteCount > 0n) {
    var copy = ensureNotNull(s).m1u();
    copy.a1u_1 = copy.a1u_1 + convertToInt(currentOffset) | 0;
    var tmp = copy;
    var tmp0 = copy.a1u_1 + convertToInt(remainingByteCount) | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = copy.b1u_1;
    tmp.b1u_1 = Math.min(tmp0, b);
    // Inline function 'kotlinx.io.Buffer.pushSegment' call
    if (out.r1t_1 == null) {
      out.r1t_1 = copy;
      out.s1t_1 = copy;
    } else if (false) {
      out.s1t_1 = ensureNotNull(out.s1t_1).n1u(copy).o1u();
      if (ensureNotNull(out.s1t_1).f1u_1 == null) {
        out.r1t_1 = out.s1t_1;
      }
    } else {
      out.s1t_1 = ensureNotNull(out.s1t_1).n1u(copy);
    }
    remainingByteCount = subtract(remainingByteCount, fromInt(copy.b1u_1 - copy.a1u_1 | 0));
    currentOffset = 0n;
    s = s.e1u_1;
  }
};
protoOf(Buffer).p1u = function () {
  var result = this.o();
  if (result === 0n)
    return 0n;
  var tail = ensureNotNull(this.s1t_1);
  if (tail.b1u_1 < 8192 && tail.d1u_1) {
    result = subtract(result, fromInt(tail.b1u_1 - tail.a1u_1 | 0));
  }
  return result;
};
protoOf(Buffer).q1u = function (position) {
  if (position < 0n || position >= this.o()) {
    throw IndexOutOfBoundsException_init_$Create$('position (' + position.toString() + ') is not within the range [0..size(' + this.o().toString() + '))');
  }
  if (position === 0n) {
    return ensureNotNull(this.r1t_1).r1u(0);
  }
  // Inline function 'kotlinx.io.seek' call
  if (this.r1t_1 == null) {
    return ensureNotNull(null).r1u(convertToInt(subtract(position, -1n)));
  }
  if (subtract(this.o(), position) < position) {
    var s = this.s1t_1;
    var offset = this.o();
    $l$loop: while (!(s == null) && offset > position) {
      offset = subtract(offset, fromInt(s.b1u_1 - s.a1u_1 | 0));
      if (offset <= position)
        break $l$loop;
      s = s.f1u_1;
    }
    var tmp0 = s;
    var offset_0 = offset;
    return ensureNotNull(tmp0).r1u(convertToInt(subtract(position, offset_0)));
  } else {
    var s_0 = this.r1t_1;
    var offset_1 = 0n;
    $l$loop_0: while (!(s_0 == null)) {
      var tmp0_0 = offset_1;
      // Inline function 'kotlin.Long.plus' call
      var other = s_0.b1u_1 - s_0.a1u_1 | 0;
      var nextOffset = add(tmp0_0, fromInt(other));
      if (nextOffset > position)
        break $l$loop_0;
      s_0 = s_0.e1u_1;
      offset_1 = nextOffset;
    }
    var tmp0_1 = s_0;
    var offset_2 = offset_1;
    return ensureNotNull(tmp0_1).r1u(convertToInt(subtract(position, offset_2)));
  }
};
protoOf(Buffer).w1 = function () {
  return this.s1u(this.o());
};
protoOf(Buffer).s1u = function (byteCount) {
  // Inline function 'kotlinx.io.checkByteCount' call
  // Inline function 'kotlin.require' call
  if (!(byteCount >= 0n)) {
    var message = 'byteCount (' + byteCount.toString() + ') < 0';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var remainingByteCount = byteCount;
  while (remainingByteCount > 0n) {
    var tmp0_elvis_lhs = this.r1t_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw EOFException_init_$Create$_0('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var head = tmp;
    var tmp0 = remainingByteCount;
    // Inline function 'kotlinx.io.minOf' call
    var b = head.b1u_1 - head.a1u_1 | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var b_0 = fromInt(b);
    var tmp$ret$4 = tmp0 <= b_0 ? tmp0 : b_0;
    var toSkip = convertToInt(tmp$ret$4);
    this.t1t_1 = subtract(this.t1t_1, fromInt(toSkip));
    remainingByteCount = subtract(remainingByteCount, fromInt(toSkip));
    head.a1u_1 = head.a1u_1 + toSkip | 0;
    if (head.a1u_1 === head.b1u_1) {
      this.g1u();
    }
  }
};
protoOf(Buffer).t1u = function (sink, startIndex, endIndex) {
  // Inline function 'kotlinx.io.checkBounds' call
  var size = sink.length;
  checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
  var tmp0_elvis_lhs = this.r1t_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return -1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var s = tmp;
  var tmp0 = endIndex - startIndex | 0;
  // Inline function 'kotlin.comparisons.minOf' call
  var b = s.o();
  var toCopy = Math.min(tmp0, b);
  s.u1u(sink, startIndex, startIndex + toCopy | 0);
  this.t1t_1 = subtract(this.t1t_1, fromInt(toCopy));
  if (isEmpty(s)) {
    this.g1u();
  }
  return toCopy;
};
protoOf(Buffer).v1u = function (sink, byteCount) {
  // Inline function 'kotlinx.io.checkByteCount' call
  // Inline function 'kotlin.require' call
  if (!(byteCount >= 0n)) {
    var message = 'byteCount (' + byteCount.toString() + ') < 0';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (this.o() === 0n)
    return -1n;
  var bytesWritten = byteCount > this.o() ? this.o() : byteCount;
  sink.w1u(this, bytesWritten);
  return bytesWritten;
};
protoOf(Buffer).x1u = function (sink, byteCount) {
  // Inline function 'kotlinx.io.checkByteCount' call
  // Inline function 'kotlin.require' call
  if (!(byteCount >= 0n)) {
    var message = 'byteCount (' + byteCount.toString() + ') < 0';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (this.o() < byteCount) {
    sink.w1u(this, this.o());
    throw EOFException_init_$Create$_0('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.o().toString() + ' bytes were written.');
  }
  sink.w1u(this, byteCount);
};
protoOf(Buffer).y1u = function (sink) {
  var byteCount = this.o();
  if (byteCount > 0n) {
    sink.w1u(this, byteCount);
  }
  return byteCount;
};
protoOf(Buffer).z1u = function () {
  return buffered(new PeekSource(this));
};
protoOf(Buffer).a1v = function (minimumCapacity) {
  // Inline function 'kotlin.require' call
  if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
    var message = 'unexpected capacity (' + minimumCapacity + '), should be in range [1, 8192]';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (this.s1t_1 == null) {
    var result = SegmentPool_instance.d1v();
    this.r1t_1 = result;
    this.s1t_1 = result;
    return result;
  }
  var t = ensureNotNull(this.s1t_1);
  if ((t.b1u_1 + minimumCapacity | 0) > 8192 || !t.d1u_1) {
    var newTail = t.n1u(SegmentPool_instance.d1v());
    this.s1t_1 = newTail;
    return newTail;
  }
  return t;
};
protoOf(Buffer).e1v = function (source, startIndex, endIndex) {
  // Inline function 'kotlinx.io.checkBounds' call
  var size = source.length;
  checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
  var currentOffset = startIndex;
  while (currentOffset < endIndex) {
    var tail = this.a1v(1);
    var tmp0 = endIndex - currentOffset | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = tail.f1v();
    var toCopy = Math.min(tmp0, b);
    tail.g1v(source, currentOffset, currentOffset + toCopy | 0);
    currentOffset = currentOffset + toCopy | 0;
  }
  var tmp = this;
  var tmp0_0 = this.t1t_1;
  // Inline function 'kotlin.Long.plus' call
  var other = endIndex - startIndex | 0;
  tmp.t1t_1 = add(tmp0_0, fromInt(other));
};
protoOf(Buffer).w1u = function (source, byteCount) {
  // Inline function 'kotlin.require' call
  if (!!(source === this)) {
    var message = 'source == this';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  checkOffsetAndCount(source.t1t_1, 0n, byteCount);
  var remainingByteCount = byteCount;
  while (remainingByteCount > 0n) {
    if (remainingByteCount < fromInt(ensureNotNull(source.r1t_1).o())) {
      var tail = this.s1t_1;
      var tmp;
      if (!(tail == null) && tail.d1u_1) {
        var tmp0 = remainingByteCount;
        // Inline function 'kotlin.Long.plus' call
        var other = tail.b1u_1;
        var tmp0_0 = add(tmp0, fromInt(other));
        // Inline function 'kotlin.Long.minus' call
        var other_0 = tail.i1v() ? 0 : tail.a1u_1;
        tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
      } else {
        tmp = false;
      }
      if (tmp) {
        ensureNotNull(source.r1t_1).k1v(tail, convertToInt(remainingByteCount));
        source.t1t_1 = subtract(source.t1t_1, remainingByteCount);
        this.t1t_1 = add(this.t1t_1, remainingByteCount);
        return Unit_instance;
      } else {
        source.r1t_1 = ensureNotNull(source.r1t_1).j1v(convertToInt(remainingByteCount));
      }
    }
    var segmentToMove = ensureNotNull(source.r1t_1);
    var movedByteCount = fromInt(segmentToMove.o());
    source.r1t_1 = segmentToMove.l1v();
    if (source.r1t_1 == null) {
      source.s1t_1 = null;
    }
    // Inline function 'kotlinx.io.Buffer.pushSegment' call
    if (this.r1t_1 == null) {
      this.r1t_1 = segmentToMove;
      this.s1t_1 = segmentToMove;
    } else if (true) {
      this.s1t_1 = ensureNotNull(this.s1t_1).n1u(segmentToMove).o1u();
      if (ensureNotNull(this.s1t_1).f1u_1 == null) {
        this.r1t_1 = this.s1t_1;
      }
    } else {
      this.s1t_1 = ensureNotNull(this.s1t_1).n1u(segmentToMove);
    }
    source.t1t_1 = subtract(source.t1t_1, movedByteCount);
    this.t1t_1 = add(this.t1t_1, movedByteCount);
    remainingByteCount = subtract(remainingByteCount, movedByteCount);
  }
};
protoOf(Buffer).m1v = function (source) {
  var totalBytesRead = 0n;
  $l$loop: while (true) {
    var readCount = source.v1u(this, 8192n);
    if (readCount === -1n)
      break $l$loop;
    totalBytesRead = add(totalBytesRead, readCount);
  }
  return totalBytesRead;
};
protoOf(Buffer).n1v = function (byte) {
  this.a1v(1).o1v(byte);
  this.t1t_1 = add(this.t1t_1, 1n);
};
protoOf(Buffer).p1v = function (short) {
  this.a1v(2).q1v(short);
  this.t1t_1 = add(this.t1t_1, 2n);
};
protoOf(Buffer).i3 = function () {
  return Unit_instance;
};
protoOf(Buffer).toString = function () {
  if (this.o() === 0n)
    return 'Buffer(size=0)';
  var maxPrintableBytes = 64;
  // Inline function 'kotlinx.io.minOf' call
  var b = this.o();
  // Inline function 'kotlin.comparisons.minOf' call
  var a = fromInt(maxPrintableBytes);
  var tmp$ret$1 = a <= b ? a : b;
  var len = convertToInt(tmp$ret$1);
  var builder = StringBuilder_init_$Create$(imul(len, 2) + (this.o() > fromInt(maxPrintableBytes) ? 1 : 0) | 0);
  var bytesWritten = 0;
  // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
  var curr = this.r1t_1;
  while (!(curr == null)) {
    var tmp0 = get_SegmentReadContextImpl();
    var segment = curr;
    var idx = 0;
    while (bytesWritten < len && idx < segment.o()) {
      var _unary__edvuaz = idx;
      idx = _unary__edvuaz + 1 | 0;
      var b_0 = tmp0.r1v(segment, _unary__edvuaz);
      bytesWritten = bytesWritten + 1 | 0;
      var tmp = get_HEX_DIGIT_CHARS();
      // Inline function 'kotlinx.io.shr' call
      var tmp$ret$2 = b_0 >> 4;
      var tmp_0 = builder.l7(tmp[tmp$ret$2 & 15]);
      var tmp_1 = get_HEX_DIGIT_CHARS();
      // Inline function 'kotlinx.io.and' call
      var tmp$ret$3 = b_0 & 15;
      tmp_0.l7(tmp_1[tmp$ret$3]);
    }
    curr = curr.e1u_1;
  }
  if (this.o() > fromInt(maxPrintableBytes)) {
    builder.l7(_Char___init__impl__6a9atx(8230));
  }
  return 'Buffer(size=' + this.o().toString() + ' hex=' + builder.toString() + ')';
};
protoOf(Buffer).g1u = function () {
  var oldHead = ensureNotNull(this.r1t_1);
  var nextHead = oldHead.e1u_1;
  this.r1t_1 = nextHead;
  if (nextHead == null) {
    this.s1t_1 = null;
  } else {
    nextHead.f1u_1 = null;
  }
  oldHead.e1u_1 = null;
  SegmentPool_instance.s1v(oldHead);
};
protoOf(Buffer).t1v = function () {
  var oldTail = ensureNotNull(this.s1t_1);
  var newTail = oldTail.f1u_1;
  this.s1t_1 = newTail;
  if (newTail == null) {
    this.r1t_1 = null;
  } else {
    newTail.e1u_1 = null;
  }
  oldTail.f1u_1 = null;
  SegmentPool_instance.s1v(oldTail);
};
function indexOf(_this__u8e3s4, byte, startIndex, endIndex) {
  startIndex = startIndex === VOID ? 0n : startIndex;
  endIndex = endIndex === VOID ? _this__u8e3s4.o() : endIndex;
  // Inline function 'kotlin.comparisons.minOf' call
  var b = _this__u8e3s4.o();
  var endOffset = endIndex <= b ? endIndex : b;
  checkBounds(_this__u8e3s4.o(), startIndex, endOffset);
  if (startIndex === endOffset)
    return -1n;
  // Inline function 'kotlinx.io.seek' call
  if (_this__u8e3s4.r1t_1 == null) {
    if (-1n === -1n) {
      return -1n;
    }
    var segment = null;
    var offset = -1n;
    do {
      // Inline function 'kotlin.check' call
      if (!(endOffset > offset)) {
        throw IllegalStateException_init_$Create$('Check failed.');
      }
      ensureNotNull(segment);
      var tmp = segment;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = convertToInt(subtract(startIndex, offset));
      var tmp_0 = Math.max(a, 0);
      var tmp0 = segment.o();
      // Inline function 'kotlin.comparisons.minOf' call
      var b_0 = convertToInt(subtract(endOffset, offset));
      var tmp$ret$3 = Math.min(tmp0, b_0);
      var idx = indexOf_0(tmp, byte, tmp_0, tmp$ret$3);
      if (!(idx === -1)) {
        return add(offset, fromInt(idx));
      }
      var tmp0_0 = offset;
      // Inline function 'kotlin.Long.plus' call
      var other = segment.o();
      offset = add(tmp0_0, fromInt(other));
      segment = segment.e1u_1;
    }
     while (!(segment == null) && offset < endOffset);
    return -1n;
  }
  if (subtract(_this__u8e3s4.o(), startIndex) < startIndex) {
    var s = _this__u8e3s4.s1t_1;
    var offset_0 = _this__u8e3s4.o();
    $l$loop: while (!(s == null) && offset_0 > startIndex) {
      offset_0 = subtract(offset_0, fromInt(s.b1u_1 - s.a1u_1 | 0));
      if (offset_0 <= startIndex)
        break $l$loop;
      s = s.f1u_1;
    }
    var tmp0_1 = s;
    var o = offset_0;
    if (o === -1n) {
      return -1n;
    }
    var segment_0 = tmp0_1;
    var offset_1 = o;
    do {
      // Inline function 'kotlin.check' call
      if (!(endOffset > offset_1)) {
        throw IllegalStateException_init_$Create$('Check failed.');
      }
      ensureNotNull(segment_0);
      var tmp_1 = segment_0;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a_0 = convertToInt(subtract(startIndex, offset_1));
      var tmp_2 = Math.max(a_0, 0);
      var tmp0_2 = segment_0.o();
      // Inline function 'kotlin.comparisons.minOf' call
      var b_1 = convertToInt(subtract(endOffset, offset_1));
      var tmp$ret$8 = Math.min(tmp0_2, b_1);
      var idx_0 = indexOf_0(tmp_1, byte, tmp_2, tmp$ret$8);
      if (!(idx_0 === -1)) {
        return add(offset_1, fromInt(idx_0));
      }
      var tmp0_3 = offset_1;
      // Inline function 'kotlin.Long.plus' call
      var other_0 = segment_0.o();
      offset_1 = add(tmp0_3, fromInt(other_0));
      segment_0 = segment_0.e1u_1;
    }
     while (!(segment_0 == null) && offset_1 < endOffset);
    return -1n;
  } else {
    var s_0 = _this__u8e3s4.r1t_1;
    var offset_2 = 0n;
    $l$loop_0: while (!(s_0 == null)) {
      var tmp0_4 = offset_2;
      // Inline function 'kotlin.Long.plus' call
      var other_1 = s_0.b1u_1 - s_0.a1u_1 | 0;
      var nextOffset = add(tmp0_4, fromInt(other_1));
      if (nextOffset > startIndex)
        break $l$loop_0;
      s_0 = s_0.e1u_1;
      offset_2 = nextOffset;
    }
    var tmp0_5 = s_0;
    var o_0 = offset_2;
    if (o_0 === -1n) {
      return -1n;
    }
    var segment_1 = tmp0_5;
    var offset_3 = o_0;
    do {
      // Inline function 'kotlin.check' call
      if (!(endOffset > offset_3)) {
        throw IllegalStateException_init_$Create$('Check failed.');
      }
      ensureNotNull(segment_1);
      var tmp_3 = segment_1;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a_1 = convertToInt(subtract(startIndex, offset_3));
      var tmp_4 = Math.max(a_1, 0);
      var tmp0_6 = segment_1.o();
      // Inline function 'kotlin.comparisons.minOf' call
      var b_2 = convertToInt(subtract(endOffset, offset_3));
      var tmp$ret$13 = Math.min(tmp0_6, b_2);
      var idx_1 = indexOf_0(tmp_3, byte, tmp_4, tmp$ret$13);
      if (!(idx_1 === -1)) {
        return add(offset_3, fromInt(idx_1));
      }
      var tmp0_7 = offset_3;
      // Inline function 'kotlin.Long.plus' call
      var other_2 = segment_1.o();
      offset_3 = add(tmp0_7, fromInt(other_2));
      segment_1 = segment_1.e1u_1;
    }
     while (!(segment_1 == null) && offset_3 < endOffset);
    return -1n;
  }
}
function readByteString(_this__u8e3s4, byteCount) {
  return UnsafeByteStringOperations_instance.q1t(readByteArray_0(_this__u8e3s4, byteCount));
}
function buffered(_this__u8e3s4) {
  return new RealSource(_this__u8e3s4);
}
function PeekSource(upstream) {
  this.u1v_1 = upstream;
  this.v1v_1 = this.u1v_1.u1t();
  this.w1v_1 = this.v1v_1.r1t_1;
  var tmp = this;
  var tmp0_safe_receiver = this.v1v_1.r1t_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a1u_1;
  tmp.x1v_1 = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
  this.y1v_1 = false;
  this.z1v_1 = 0n;
}
protoOf(PeekSource).v1u = function (sink, byteCount) {
  // Inline function 'kotlin.check' call
  if (!!this.y1v_1) {
    var message = 'Source is closed.';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  // Inline function 'kotlinx.io.checkByteCount' call
  // Inline function 'kotlin.require' call
  if (!(byteCount >= 0n)) {
    var message_0 = 'byteCount (' + byteCount.toString() + ') < 0';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.check' call
  if (!(this.w1v_1 == null || (this.w1v_1 === this.v1v_1.r1t_1 && this.x1v_1 === ensureNotNull(this.v1v_1.r1t_1).a1u_1))) {
    var message_1 = 'Peek source is invalid because upstream source was used';
    throw IllegalStateException_init_$Create$(toString(message_1));
  }
  if (byteCount === 0n)
    return 0n;
  // Inline function 'kotlin.Long.plus' call
  var this_0 = this.z1v_1;
  var tmp$ret$7 = add(this_0, fromInt(1));
  if (!this.u1v_1.x1t(tmp$ret$7))
    return -1n;
  if (this.w1v_1 == null && !(this.v1v_1.r1t_1 == null)) {
    this.w1v_1 = this.v1v_1.r1t_1;
    this.x1v_1 = ensureNotNull(this.v1v_1.r1t_1).a1u_1;
  }
  // Inline function 'kotlin.comparisons.minOf' call
  var b = subtract(this.v1v_1.o(), this.z1v_1);
  var toCopy = byteCount <= b ? byteCount : b;
  this.v1v_1.l1u(sink, this.z1v_1, add(this.z1v_1, toCopy));
  this.z1v_1 = add(this.z1v_1, toCopy);
  return toCopy;
};
protoOf(PeekSource).i3 = function () {
  this.y1v_1 = true;
};
function RealSource(source) {
  this.a1w_1 = source;
  this.b1w_1 = false;
  this.c1w_1 = new Buffer();
}
protoOf(RealSource).u1t = function () {
  return this.c1w_1;
};
protoOf(RealSource).v1u = function (sink, byteCount) {
  // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
  // Inline function 'kotlin.check' call
  if (!!this.b1w_1) {
    var message = 'Source is closed.';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(byteCount >= 0n)) {
    var message_0 = 'byteCount: ' + byteCount.toString();
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  if (this.c1w_1.o() === 0n) {
    var read = this.a1w_1.v1u(this.c1w_1, 8192n);
    if (read === -1n)
      return -1n;
  }
  // Inline function 'kotlin.comparisons.minOf' call
  var b = this.c1w_1.o();
  var toRead = byteCount <= b ? byteCount : b;
  return this.c1w_1.v1u(sink, toRead);
};
protoOf(RealSource).v1t = function () {
  // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
  // Inline function 'kotlin.check' call
  if (!!this.b1w_1) {
    var message = 'Source is closed.';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  return this.c1w_1.v1t() && this.a1w_1.v1u(this.c1w_1, 8192n) === -1n;
};
protoOf(RealSource).w1t = function (byteCount) {
  if (!this.x1t(byteCount))
    throw EOFException_init_$Create$_0("Source doesn't contain required number of bytes (" + byteCount.toString() + ').');
};
protoOf(RealSource).x1t = function (byteCount) {
  // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
  // Inline function 'kotlin.check' call
  if (!!this.b1w_1) {
    var message = 'Source is closed.';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(byteCount >= 0n)) {
    var message_0 = 'byteCount: ' + byteCount.toString();
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  while (this.c1w_1.o() < byteCount) {
    if (this.a1w_1.v1u(this.c1w_1, 8192n) === -1n)
      return false;
  }
  return true;
};
protoOf(RealSource).y1t = function () {
  this.w1t(1n);
  return this.c1w_1.y1t();
};
protoOf(RealSource).t1u = function (sink, startIndex, endIndex) {
  // Inline function 'kotlinx.io.checkBounds' call
  var size = sink.length;
  checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
  if (this.c1w_1.o() === 0n) {
    var read = this.a1w_1.v1u(this.c1w_1, 8192n);
    if (read === -1n)
      return -1;
  }
  var tmp0 = endIndex - startIndex | 0;
  // Inline function 'kotlinx.io.minOf' call
  var b = this.c1w_1.o();
  // Inline function 'kotlin.comparisons.minOf' call
  var a = fromInt(tmp0);
  var tmp$ret$2 = a <= b ? a : b;
  var toRead = convertToInt(tmp$ret$2);
  return this.c1w_1.t1u(sink, startIndex, startIndex + toRead | 0);
};
protoOf(RealSource).x1u = function (sink, byteCount) {
  try {
    this.w1t(byteCount);
  } catch ($p) {
    if ($p instanceof EOFException) {
      var e = $p;
      sink.w1u(this.c1w_1, this.c1w_1.o());
      throw e;
    } else {
      throw $p;
    }
  }
  this.c1w_1.x1u(sink, byteCount);
};
protoOf(RealSource).y1u = function (sink) {
  var totalBytesWritten = 0n;
  while (!(this.a1w_1.v1u(this.c1w_1, 8192n) === -1n)) {
    var emitByteCount = this.c1w_1.p1u();
    if (emitByteCount > 0n) {
      totalBytesWritten = add(totalBytesWritten, emitByteCount);
      sink.w1u(this.c1w_1, emitByteCount);
    }
  }
  if (this.c1w_1.o() > 0n) {
    totalBytesWritten = add(totalBytesWritten, this.c1w_1.o());
    sink.w1u(this.c1w_1, this.c1w_1.o());
  }
  return totalBytesWritten;
};
protoOf(RealSource).i1u = function () {
  this.w1t(2n);
  return this.c1w_1.i1u();
};
protoOf(RealSource).z1u = function () {
  // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
  // Inline function 'kotlin.check' call
  if (!!this.b1w_1) {
    var message = 'Source is closed.';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  return buffered(new PeekSource(this));
};
protoOf(RealSource).i3 = function () {
  if (this.b1w_1)
    return Unit_instance;
  this.b1w_1 = true;
  this.a1w_1.i3();
  this.c1w_1.w1();
};
protoOf(RealSource).toString = function () {
  return 'buffered(' + toString(this.a1w_1) + ')';
};
function Segment_init_$Init$($this) {
  Segment.call($this);
  $this.z1t_1 = new Int8Array(8192);
  $this.d1u_1 = true;
  $this.c1u_1 = null;
  return $this;
}
function Segment_init_$Create$() {
  return Segment_init_$Init$(objectCreate(protoOf(Segment)));
}
function Segment_init_$Init$_0(data, pos, limit, shareToken, owner, $this) {
  Segment.call($this);
  $this.z1t_1 = data;
  $this.a1u_1 = pos;
  $this.b1u_1 = limit;
  $this.c1u_1 = shareToken;
  $this.d1u_1 = owner;
  return $this;
}
function Segment_init_$Create$_0(data, pos, limit, shareToken, owner) {
  return Segment_init_$Init$_0(data, pos, limit, shareToken, owner, objectCreate(protoOf(Segment)));
}
function Companion() {
  this.d1w_1 = 8192;
  this.e1w_1 = 1024;
}
protoOf(Companion).f1w = function () {
  return Segment_init_$Create$();
};
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
protoOf(Segment).i1v = function () {
  var tmp0_safe_receiver = this.c1u_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g1w();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
};
protoOf(Segment).m1u = function () {
  var tmp0_elvis_lhs = this.c1u_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = SegmentPool_instance.h1w();
    this.c1u_1 = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var t = tmp;
  var tmp_0 = this.a1u_1;
  var tmp_1 = this.b1u_1;
  // Inline function 'kotlin.also' call
  t.i1w();
  return Segment_init_$Create$_0(this.z1t_1, tmp_0, tmp_1, t, false);
};
protoOf(Segment).l1v = function () {
  var result = this.e1u_1;
  if (!(this.f1u_1 == null)) {
    ensureNotNull(this.f1u_1).e1u_1 = this.e1u_1;
  }
  if (!(this.e1u_1 == null)) {
    ensureNotNull(this.e1u_1).f1u_1 = this.f1u_1;
  }
  this.e1u_1 = null;
  this.f1u_1 = null;
  return result;
};
protoOf(Segment).n1u = function (segment) {
  segment.f1u_1 = this;
  segment.e1u_1 = this.e1u_1;
  if (!(this.e1u_1 == null)) {
    ensureNotNull(this.e1u_1).f1u_1 = segment;
  }
  this.e1u_1 = segment;
  return segment;
};
protoOf(Segment).j1v = function (byteCount) {
  // Inline function 'kotlin.require' call
  if (!(byteCount > 0 && byteCount <= (this.b1u_1 - this.a1u_1 | 0))) {
    var message = 'byteCount out of range';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var prefix;
  if (byteCount >= 1024) {
    prefix = this.m1u();
  } else {
    prefix = SegmentPool_instance.d1v();
    var tmp0 = this.z1t_1;
    var tmp2 = prefix.z1t_1;
    var tmp4 = this.a1u_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = this.a1u_1 + byteCount | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, tmp2, 0, tmp4, endIndex);
  }
  prefix.b1u_1 = prefix.a1u_1 + byteCount | 0;
  this.a1u_1 = this.a1u_1 + byteCount | 0;
  if (!(this.f1u_1 == null)) {
    ensureNotNull(this.f1u_1).n1u(prefix);
  } else {
    prefix.e1u_1 = this;
    this.f1u_1 = prefix;
  }
  return prefix;
};
protoOf(Segment).o1u = function () {
  // Inline function 'kotlin.check' call
  if (!!(this.f1u_1 == null)) {
    var message = 'cannot compact';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  if (!ensureNotNull(this.f1u_1).d1u_1)
    return this;
  var byteCount = this.b1u_1 - this.a1u_1 | 0;
  var availableByteCount = (8192 - ensureNotNull(this.f1u_1).b1u_1 | 0) + (ensureNotNull(this.f1u_1).i1v() ? 0 : ensureNotNull(this.f1u_1).a1u_1) | 0;
  if (byteCount > availableByteCount)
    return this;
  var predecessor = this.f1u_1;
  this.k1v(ensureNotNull(predecessor), byteCount);
  var successor = this.l1v();
  // Inline function 'kotlin.check' call
  if (!(successor == null)) {
    throw IllegalStateException_init_$Create$('Check failed.');
  }
  SegmentPool_instance.s1v(this);
  return predecessor;
};
protoOf(Segment).o1v = function (byte) {
  var _unary__edvuaz = this.b1u_1;
  this.b1u_1 = _unary__edvuaz + 1 | 0;
  this.z1t_1[_unary__edvuaz] = byte;
};
protoOf(Segment).q1v = function (short) {
  var data = this.z1t_1;
  var limit = this.b1u_1;
  var _unary__edvuaz = limit;
  limit = _unary__edvuaz + 1 | 0;
  data[_unary__edvuaz] = toByte((short >>> 8 | 0) & 255);
  var _unary__edvuaz_0 = limit;
  limit = _unary__edvuaz_0 + 1 | 0;
  data[_unary__edvuaz_0] = toByte(short & 255);
  this.b1u_1 = limit;
};
protoOf(Segment).h1u = function () {
  var _unary__edvuaz = this.a1u_1;
  this.a1u_1 = _unary__edvuaz + 1 | 0;
  return this.z1t_1[_unary__edvuaz];
};
protoOf(Segment).j1u = function () {
  var data = this.z1t_1;
  var pos = this.a1u_1;
  var _unary__edvuaz = pos;
  pos = _unary__edvuaz + 1 | 0;
  // Inline function 'kotlinx.io.and' call
  var tmp = (data[_unary__edvuaz] & 255) << 8;
  var _unary__edvuaz_0 = pos;
  pos = _unary__edvuaz_0 + 1 | 0;
  // Inline function 'kotlinx.io.and' call
  var tmp$ret$1 = data[_unary__edvuaz_0] & 255;
  var s = toShort(tmp | tmp$ret$1);
  this.a1u_1 = pos;
  return s;
};
protoOf(Segment).k1v = function (sink, byteCount) {
  // Inline function 'kotlin.check' call
  if (!sink.d1u_1) {
    var message = 'only owner can write';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  if ((sink.b1u_1 + byteCount | 0) > 8192) {
    if (sink.i1v())
      throw IllegalArgumentException_init_$Create$_0();
    if (((sink.b1u_1 + byteCount | 0) - sink.a1u_1 | 0) > 8192)
      throw IllegalArgumentException_init_$Create$_0();
    var tmp0 = sink.z1t_1;
    var tmp2 = sink.z1t_1;
    var tmp4 = sink.a1u_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = sink.b1u_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, tmp2, 0, tmp4, endIndex);
    sink.b1u_1 = sink.b1u_1 - sink.a1u_1 | 0;
    sink.a1u_1 = 0;
  }
  var tmp0_0 = this.z1t_1;
  var tmp2_0 = sink.z1t_1;
  var tmp4_0 = sink.b1u_1;
  var tmp6 = this.a1u_1;
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex_0 = this.a1u_1 + byteCount | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = tmp0_0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp_0, tmp2_0, tmp4_0, tmp6, endIndex_0);
  sink.b1u_1 = sink.b1u_1 + byteCount | 0;
  this.a1u_1 = this.a1u_1 + byteCount | 0;
};
protoOf(Segment).u1u = function (dst, dstStartOffset, dstEndOffset) {
  var len = dstEndOffset - dstStartOffset | 0;
  var tmp0 = this.z1t_1;
  var tmp6 = this.a1u_1;
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = this.a1u_1 + len | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = tmp0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstStartOffset, tmp6, endIndex);
  this.a1u_1 = this.a1u_1 + len | 0;
};
protoOf(Segment).g1v = function (src, srcStartOffset, srcEndOffset) {
  var tmp2 = this.z1t_1;
  // Inline function 'kotlin.collections.copyInto' call
  var destinationOffset = this.b1u_1;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, tmp2, destinationOffset, srcStartOffset, srcEndOffset);
  this.b1u_1 = this.b1u_1 + (srcEndOffset - srcStartOffset | 0) | 0;
};
protoOf(Segment).o = function () {
  return this.b1u_1 - this.a1u_1 | 0;
};
protoOf(Segment).f1v = function () {
  return this.z1t_1.length - this.b1u_1 | 0;
};
protoOf(Segment).j1w = function (readOnly) {
  return this.z1t_1;
};
protoOf(Segment).r1u = function (index) {
  return this.z1t_1[this.a1u_1 + index | 0];
};
protoOf(Segment).k1w = function (index, value) {
  this.z1t_1[this.b1u_1 + index | 0] = value;
};
protoOf(Segment).l1w = function (index, b0, b1) {
  var d = this.z1t_1;
  var l = this.b1u_1;
  d[l + index | 0] = b0;
  d[(l + index | 0) + 1 | 0] = b1;
};
protoOf(Segment).m1w = function (index, b0, b1, b2) {
  var d = this.z1t_1;
  var l = this.b1u_1;
  d[l + index | 0] = b0;
  d[(l + index | 0) + 1 | 0] = b1;
  d[(l + index | 0) + 2 | 0] = b2;
};
protoOf(Segment).n1w = function (index, b0, b1, b2, b3) {
  var d = this.z1t_1;
  var l = this.b1u_1;
  d[l + index | 0] = b0;
  d[(l + index | 0) + 1 | 0] = b1;
  d[(l + index | 0) + 2 | 0] = b2;
  d[(l + index | 0) + 3 | 0] = b3;
};
function Segment() {
  this.a1u_1 = 0;
  this.b1u_1 = 0;
  this.c1u_1 = null;
  this.d1u_1 = false;
  this.e1u_1 = null;
  this.f1u_1 = null;
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.o() === 0;
}
function SegmentCopyTracker() {
}
function AlwaysSharedCopyTracker() {
  AlwaysSharedCopyTracker_instance = this;
  SegmentCopyTracker.call(this);
}
protoOf(AlwaysSharedCopyTracker).g1w = function () {
  return true;
};
protoOf(AlwaysSharedCopyTracker).i1w = function () {
  return Unit_instance;
};
var AlwaysSharedCopyTracker_instance;
function AlwaysSharedCopyTracker_getInstance() {
  if (AlwaysSharedCopyTracker_instance == null)
    new AlwaysSharedCopyTracker();
  return AlwaysSharedCopyTracker_instance;
}
function indexOf_0(_this__u8e3s4, byte, startOffset, endOffset) {
  // Inline function 'kotlin.require' call
  if (!(0 <= startOffset ? startOffset < _this__u8e3s4.o() : false)) {
    var message = '' + startOffset;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(startOffset <= endOffset ? endOffset <= _this__u8e3s4.o() : false)) {
    var message_0 = '' + endOffset;
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var p = _this__u8e3s4.a1u_1;
  var data = _this__u8e3s4.j1w(true);
  var inductionVariable = startOffset;
  if (inductionVariable < endOffset)
    do {
      var idx = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (data[p + idx | 0] === byte) {
        return idx;
      }
    }
     while (inductionVariable < endOffset);
  return -1;
}
function Sink() {
}
function Source() {
}
function readByteArray(_this__u8e3s4) {
  return readByteArrayImpl(_this__u8e3s4, -1);
}
function readByteArray_0(_this__u8e3s4, byteCount) {
  // Inline function 'kotlinx.io.checkByteCount' call
  var byteCount_0 = fromInt(byteCount);
  // Inline function 'kotlin.require' call
  if (!(byteCount_0 >= 0n)) {
    var message = 'byteCount (' + byteCount_0.toString() + ') < 0';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return readByteArrayImpl(_this__u8e3s4, byteCount);
}
function indexOf_1(_this__u8e3s4, byte, startIndex, endIndex) {
  startIndex = startIndex === VOID ? 0n : startIndex;
  endIndex = endIndex === VOID ? 9223372036854775807n : endIndex;
  // Inline function 'kotlin.require' call
  if (!(0n <= startIndex ? startIndex <= endIndex : false)) {
    var tmp;
    if (endIndex < 0n) {
      tmp = 'startIndex (' + startIndex.toString() + ') and endIndex (' + endIndex.toString() + ') should be non negative';
    } else {
      tmp = 'startIndex (' + startIndex.toString() + ') is not within the range [0..endIndex(' + endIndex.toString() + '))';
    }
    var message = tmp;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (startIndex === endIndex)
    return -1n;
  var offset = startIndex;
  $l$loop: while (true) {
    var tmp_0;
    if (offset < endIndex) {
      // Inline function 'kotlin.Long.plus' call
      var this_0 = offset;
      var tmp$ret$2 = add(this_0, fromInt(1));
      tmp_0 = _this__u8e3s4.x1t(tmp$ret$2);
    } else {
      tmp_0 = false;
    }
    if (!tmp_0) {
      break $l$loop;
    }
    var tmp_1 = _this__u8e3s4.u1t();
    var tmp_2 = offset;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = _this__u8e3s4.u1t().o();
    var tmp$ret$3 = endIndex <= b ? endIndex : b;
    var idx = indexOf(tmp_1, byte, tmp_2, tmp$ret$3);
    if (!(idx === -1n)) {
      return idx;
    }
    offset = _this__u8e3s4.u1t().o();
  }
  return -1n;
}
function readByteArrayImpl(_this__u8e3s4, size) {
  var arraySize = size;
  if (size === -1) {
    var fetchSize = 2147483647n;
    while (_this__u8e3s4.u1t().o() < 2147483647n && _this__u8e3s4.x1t(fetchSize)) {
      // Inline function 'kotlin.Long.times' call
      var this_0 = fetchSize;
      fetchSize = multiply(this_0, fromInt(2));
    }
    // Inline function 'kotlin.check' call
    if (!(_this__u8e3s4.u1t().o() < 2147483647n)) {
      var message = "Can't create an array of size " + _this__u8e3s4.u1t().o().toString();
      throw IllegalStateException_init_$Create$(toString(message));
    }
    arraySize = convertToInt(_this__u8e3s4.u1t().o());
  } else {
    _this__u8e3s4.w1t(fromInt(size));
  }
  var array = new Int8Array(arraySize);
  readTo(_this__u8e3s4.u1t(), array);
  return array;
}
function readTo(_this__u8e3s4, sink, startIndex, endIndex) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? sink.length : endIndex;
  // Inline function 'kotlinx.io.checkBounds' call
  var size = sink.length;
  checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
  var offset = startIndex;
  while (offset < endIndex) {
    var bytesRead = _this__u8e3s4.t1u(sink, offset, endIndex);
    if (bytesRead === -1) {
      throw EOFException_init_$Create$_0('Source exhausted before reading ' + (endIndex - startIndex | 0) + ' bytes. ' + ('Only ' + bytesRead + ' bytes were read.'));
    }
    offset = offset + bytesRead | 0;
  }
}
function readString(_this__u8e3s4) {
  return commonReadUtf8(_this__u8e3s4, _this__u8e3s4.o());
}
function readString_0(_this__u8e3s4) {
  _this__u8e3s4.x1t(9223372036854775807n);
  return commonReadUtf8(_this__u8e3s4.u1t(), _this__u8e3s4.u1t().o());
}
function readString_1(_this__u8e3s4, byteCount) {
  _this__u8e3s4.w1t(byteCount);
  return commonReadUtf8(_this__u8e3s4.u1t(), byteCount);
}
function writeString(_this__u8e3s4, string, startIndex, endIndex) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? string.length : endIndex;
  // Inline function 'kotlinx.io.checkBounds' call
  var size = string.length;
  checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
  // Inline function 'kotlinx.io.writeToInternalBuffer' call
  // Inline function 'kotlinx.io.commonWriteUtf8' call
  var this_0 = _this__u8e3s4.u1t();
  var i = startIndex;
  while (i < endIndex) {
    var p0 = i;
    // Inline function 'kotlin.code' call
    var this_1 = charCodeAt(string, p0);
    var c = Char__toInt_impl_vasixd(this_1);
    if (c < 128) {
      $l$block_0: {
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
        var tail = this_0.a1v(1);
        var ctx = get_SegmentWriteContextImpl();
        var segmentOffset = -i | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = i + tail.f1v() | 0;
        var runLimit = Math.min(endIndex, b);
        var _unary__edvuaz = i;
        i = _unary__edvuaz + 1 | 0;
        ctx.r1w(tail, segmentOffset + _unary__edvuaz | 0, toByte(c));
        $l$loop: while (i < runLimit) {
          var p0_0 = i;
          // Inline function 'kotlin.code' call
          var this_2 = charCodeAt(string, p0_0);
          c = Char__toInt_impl_vasixd(this_2);
          if (c >= 128)
            break $l$loop;
          var _unary__edvuaz_0 = i;
          i = _unary__edvuaz_0 + 1 | 0;
          ctx.r1w(tail, segmentOffset + _unary__edvuaz_0 | 0, toByte(c));
        }
        var bytesWritten = i + segmentOffset | 0;
        if (bytesWritten === 1) {
          tail.b1u_1 = tail.b1u_1 + bytesWritten | 0;
          var tmp = this_0;
          // Inline function 'kotlin.Long.plus' call
          var this_3 = this_0.t1t_1;
          tmp.t1t_1 = add(this_3, fromInt(bytesWritten));
          break $l$block_0;
        }
        // Inline function 'kotlin.check' call
        if (!(0 <= bytesWritten ? bytesWritten <= tail.f1v() : false)) {
          var message = 'Invalid number of bytes written: ' + bytesWritten + '. Should be in 0..' + tail.f1v();
          throw IllegalStateException_init_$Create$(toString(message));
        }
        if (!(bytesWritten === 0)) {
          tail.b1u_1 = tail.b1u_1 + bytesWritten | 0;
          var tmp_0 = this_0;
          // Inline function 'kotlin.Long.plus' call
          var this_4 = this_0.t1t_1;
          tmp_0.t1t_1 = add(this_4, fromInt(bytesWritten));
          break $l$block_0;
        }
        if (isEmpty(tail)) {
          this_0.t1v();
        }
      }
    } else if (c < 2048) {
      $l$block_2: {
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
        var tail_0 = this_0.a1v(2);
        get_SegmentWriteContextImpl().q1w(tail_0, 0, toByte(c >> 6 | 192), toByte(c & 63 | 128));
        var bytesWritten_0 = 2;
        if (bytesWritten_0 === 2) {
          tail_0.b1u_1 = tail_0.b1u_1 + bytesWritten_0 | 0;
          var tmp_1 = this_0;
          // Inline function 'kotlin.Long.plus' call
          var this_5 = this_0.t1t_1;
          tmp_1.t1t_1 = add(this_5, fromInt(bytesWritten_0));
          break $l$block_2;
        }
        // Inline function 'kotlin.check' call
        if (!(0 <= bytesWritten_0 ? bytesWritten_0 <= tail_0.f1v() : false)) {
          var message_0 = 'Invalid number of bytes written: ' + bytesWritten_0 + '. Should be in 0..' + tail_0.f1v();
          throw IllegalStateException_init_$Create$(toString(message_0));
        }
        if (!(bytesWritten_0 === 0)) {
          tail_0.b1u_1 = tail_0.b1u_1 + bytesWritten_0 | 0;
          var tmp_2 = this_0;
          // Inline function 'kotlin.Long.plus' call
          var this_6 = this_0.t1t_1;
          tmp_2.t1t_1 = add(this_6, fromInt(bytesWritten_0));
          break $l$block_2;
        }
        if (isEmpty(tail_0)) {
          this_0.t1v();
        }
      }
      i = i + 1 | 0;
    } else if (c < 55296 || c > 57343) {
      $l$block_4: {
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
        var tail_1 = this_0.a1v(3);
        get_SegmentWriteContextImpl().p1w(tail_1, 0, toByte(c >> 12 | 224), toByte(c >> 6 & 63 | 128), toByte(c & 63 | 128));
        var bytesWritten_1 = 3;
        if (bytesWritten_1 === 3) {
          tail_1.b1u_1 = tail_1.b1u_1 + bytesWritten_1 | 0;
          var tmp_3 = this_0;
          // Inline function 'kotlin.Long.plus' call
          var this_7 = this_0.t1t_1;
          tmp_3.t1t_1 = add(this_7, fromInt(bytesWritten_1));
          break $l$block_4;
        }
        // Inline function 'kotlin.check' call
        if (!(0 <= bytesWritten_1 ? bytesWritten_1 <= tail_1.f1v() : false)) {
          var message_1 = 'Invalid number of bytes written: ' + bytesWritten_1 + '. Should be in 0..' + tail_1.f1v();
          throw IllegalStateException_init_$Create$(toString(message_1));
        }
        if (!(bytesWritten_1 === 0)) {
          tail_1.b1u_1 = tail_1.b1u_1 + bytesWritten_1 | 0;
          var tmp_4 = this_0;
          // Inline function 'kotlin.Long.plus' call
          var this_8 = this_0.t1t_1;
          tmp_4.t1t_1 = add(this_8, fromInt(bytesWritten_1));
          break $l$block_4;
        }
        if (isEmpty(tail_1)) {
          this_0.t1v();
        }
      }
      i = i + 1 | 0;
    } else {
      var tmp_5;
      if ((i + 1 | 0) < endIndex) {
        var p0_1 = i + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_9 = charCodeAt(string, p0_1);
        tmp_5 = Char__toInt_impl_vasixd(this_9);
      } else {
        tmp_5 = 0;
      }
      var low = tmp_5;
      if (c > 56319 || !(56320 <= low ? low <= 57343 : false)) {
        // Inline function 'kotlin.code' call
        var this_10 = _Char___init__impl__6a9atx(63);
        var tmp$ret$26 = Char__toInt_impl_vasixd(this_10);
        this_0.n1v(toByte(tmp$ret$26));
        i = i + 1 | 0;
      } else {
        var codePoint = 65536 + ((c & 1023) << 10 | low & 1023) | 0;
        $l$block_6: {
          // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
          var tail_2 = this_0.a1v(4);
          get_SegmentWriteContextImpl().o1w(tail_2, 0, toByte(codePoint >> 18 | 240), toByte(codePoint >> 12 & 63 | 128), toByte(codePoint >> 6 & 63 | 128), toByte(codePoint & 63 | 128));
          var bytesWritten_2 = 4;
          if (bytesWritten_2 === 4) {
            tail_2.b1u_1 = tail_2.b1u_1 + bytesWritten_2 | 0;
            var tmp_6 = this_0;
            // Inline function 'kotlin.Long.plus' call
            var this_11 = this_0.t1t_1;
            tmp_6.t1t_1 = add(this_11, fromInt(bytesWritten_2));
            break $l$block_6;
          }
          // Inline function 'kotlin.check' call
          if (!(0 <= bytesWritten_2 ? bytesWritten_2 <= tail_2.f1v() : false)) {
            var message_2 = 'Invalid number of bytes written: ' + bytesWritten_2 + '. Should be in 0..' + tail_2.f1v();
            throw IllegalStateException_init_$Create$(toString(message_2));
          }
          if (!(bytesWritten_2 === 0)) {
            tail_2.b1u_1 = tail_2.b1u_1 + bytesWritten_2 | 0;
            var tmp_7 = this_0;
            // Inline function 'kotlin.Long.plus' call
            var this_12 = this_0.t1t_1;
            tmp_7.t1t_1 = add(this_12, fromInt(bytesWritten_2));
            break $l$block_6;
          }
          if (isEmpty(tail_2)) {
            this_0.t1v();
          }
        }
        i = i + 2 | 0;
      }
    }
  }
  _this__u8e3s4.k1u();
}
function commonReadUtf8(_this__u8e3s4, byteCount) {
  if (byteCount === 0n)
    return '';
  // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
  var curr = _this__u8e3s4.r1t_1;
  while (!(curr == null)) {
    get_SegmentReadContextImpl();
    if (fromInt(curr.o()) >= byteCount) {
      var result = '';
      // Inline function 'kotlinx.io.unsafe.withData' call
      var tmp0 = curr.j1w(true);
      var tmp2 = curr.a1u_1;
      var tmp0_0 = curr.b1u_1;
      // Inline function 'kotlin.math.min' call
      var b = tmp2 + convertToInt(byteCount) | 0;
      var tmp$ret$0 = Math.min(tmp0_0, b);
      result = commonToUtf8String(tmp0, tmp2, tmp$ret$0);
      _this__u8e3s4.s1u(byteCount);
      return result;
    }
    return commonToUtf8String(readByteArray_0(_this__u8e3s4, convertToInt(byteCount)));
  }
  // Inline function 'kotlin.error' call
  var message = 'Unreacheable';
  throw IllegalStateException_init_$Create$(toString(message));
}
function commonToUtf8String(_this__u8e3s4, beginIndex, endIndex) {
  beginIndex = beginIndex === VOID ? 0 : beginIndex;
  endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
  if (beginIndex < 0 || endIndex > _this__u8e3s4.length || beginIndex > endIndex) {
    throw IndexOutOfBoundsException_init_$Create$('size=' + _this__u8e3s4.length + ' beginIndex=' + beginIndex + ' endIndex=' + endIndex);
  }
  var chars = charArray(endIndex - beginIndex | 0);
  var length = 0;
  // Inline function 'kotlinx.io.internal.processUtf16Chars' call
  var index = beginIndex;
  while (index < endIndex) {
    var b0 = _this__u8e3s4[index];
    if (b0 >= 0) {
      var c = numberToChar(b0);
      var _unary__edvuaz = length;
      length = _unary__edvuaz + 1 | 0;
      chars[_unary__edvuaz] = c;
      index = index + 1 | 0;
      while (index < endIndex && _this__u8e3s4[index] >= 0) {
        var _unary__edvuaz_0 = index;
        index = _unary__edvuaz_0 + 1 | 0;
        var c_0 = numberToChar(_this__u8e3s4[_unary__edvuaz_0]);
        var _unary__edvuaz_1 = length;
        length = _unary__edvuaz_1 + 1 | 0;
        chars[_unary__edvuaz_1] = c_0;
      }
    } else {
      // Inline function 'kotlinx.io.shr' call
      if (b0 >> 5 === -2) {
        var tmp = index;
        var tmp2 = index;
        var tmp$ret$5;
        $l$block_0: {
          // Inline function 'kotlinx.io.internal.process2Utf8Bytes' call
          if (endIndex <= (tmp2 + 1 | 0)) {
            var c_1 = numberToChar(65533);
            var _unary__edvuaz_2 = length;
            length = _unary__edvuaz_2 + 1 | 0;
            chars[_unary__edvuaz_2] = c_1;
            tmp$ret$5 = 1;
            break $l$block_0;
          }
          var b0_0 = _this__u8e3s4[tmp2];
          var b1 = _this__u8e3s4[tmp2 + 1 | 0];
          // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
          // Inline function 'kotlinx.io.and' call
          if (!((b1 & 192) === 128)) {
            var c_2 = numberToChar(65533);
            var _unary__edvuaz_3 = length;
            length = _unary__edvuaz_3 + 1 | 0;
            chars[_unary__edvuaz_3] = c_2;
            tmp$ret$5 = 1;
            break $l$block_0;
          }
          var codePoint = 3968 ^ b1 ^ b0_0 << 6;
          if (codePoint < 128) {
            var c_3 = numberToChar(65533);
            var _unary__edvuaz_4 = length;
            length = _unary__edvuaz_4 + 1 | 0;
            chars[_unary__edvuaz_4] = c_3;
          } else {
            var c_4 = numberToChar(codePoint);
            var _unary__edvuaz_5 = length;
            length = _unary__edvuaz_5 + 1 | 0;
            chars[_unary__edvuaz_5] = c_4;
          }
          tmp$ret$5 = 2;
        }
        index = tmp + tmp$ret$5 | 0;
      } else {
        // Inline function 'kotlinx.io.shr' call
        if (b0 >> 4 === -2) {
          var tmp_0 = index;
          var tmp2_0 = index;
          var tmp$ret$19;
          $l$block_4: {
            // Inline function 'kotlinx.io.internal.process3Utf8Bytes' call
            if (endIndex <= (tmp2_0 + 2 | 0)) {
              var c_5 = numberToChar(65533);
              var _unary__edvuaz_6 = length;
              length = _unary__edvuaz_6 + 1 | 0;
              chars[_unary__edvuaz_6] = c_5;
              var tmp_1;
              if (endIndex <= (tmp2_0 + 1 | 0)) {
                tmp_1 = true;
              } else {
                // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                // Inline function 'kotlinx.io.and' call
                tmp_1 = !((_this__u8e3s4[tmp2_0 + 1 | 0] & 192) === 128);
              }
              if (tmp_1) {
                tmp$ret$19 = 1;
                break $l$block_4;
              } else {
                tmp$ret$19 = 2;
                break $l$block_4;
              }
            }
            var b0_1 = _this__u8e3s4[tmp2_0];
            var b1_0 = _this__u8e3s4[tmp2_0 + 1 | 0];
            // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
            // Inline function 'kotlinx.io.and' call
            if (!((b1_0 & 192) === 128)) {
              var c_6 = numberToChar(65533);
              var _unary__edvuaz_7 = length;
              length = _unary__edvuaz_7 + 1 | 0;
              chars[_unary__edvuaz_7] = c_6;
              tmp$ret$19 = 1;
              break $l$block_4;
            }
            var b2 = _this__u8e3s4[tmp2_0 + 2 | 0];
            // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
            // Inline function 'kotlinx.io.and' call
            if (!((b2 & 192) === 128)) {
              var c_7 = numberToChar(65533);
              var _unary__edvuaz_8 = length;
              length = _unary__edvuaz_8 + 1 | 0;
              chars[_unary__edvuaz_8] = c_7;
              tmp$ret$19 = 2;
              break $l$block_4;
            }
            var codePoint_0 = -123008 ^ b2 ^ b1_0 << 6 ^ b0_1 << 12;
            if (codePoint_0 < 2048) {
              var c_8 = numberToChar(65533);
              var _unary__edvuaz_9 = length;
              length = _unary__edvuaz_9 + 1 | 0;
              chars[_unary__edvuaz_9] = c_8;
            } else if (55296 <= codePoint_0 ? codePoint_0 <= 57343 : false) {
              var c_9 = numberToChar(65533);
              var _unary__edvuaz_10 = length;
              length = _unary__edvuaz_10 + 1 | 0;
              chars[_unary__edvuaz_10] = c_9;
            } else {
              var c_10 = numberToChar(codePoint_0);
              var _unary__edvuaz_11 = length;
              length = _unary__edvuaz_11 + 1 | 0;
              chars[_unary__edvuaz_11] = c_10;
            }
            tmp$ret$19 = 3;
          }
          index = tmp_0 + tmp$ret$19 | 0;
        } else {
          // Inline function 'kotlinx.io.shr' call
          if (b0 >> 3 === -2) {
            var tmp_2 = index;
            var tmp2_1 = index;
            var tmp$ret$41;
            $l$block_10: {
              // Inline function 'kotlinx.io.internal.process4Utf8Bytes' call
              if (endIndex <= (tmp2_1 + 3 | 0)) {
                if (!(65533 === 65533)) {
                  var c_11 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_12 = length;
                  length = _unary__edvuaz_12 + 1 | 0;
                  chars[_unary__edvuaz_12] = c_11;
                  var c_12 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_13 = length;
                  length = _unary__edvuaz_13 + 1 | 0;
                  chars[_unary__edvuaz_13] = c_12;
                } else {
                  var c_13 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_14 = length;
                  length = _unary__edvuaz_14 + 1 | 0;
                  chars[_unary__edvuaz_14] = c_13;
                }
                var tmp_3;
                if (endIndex <= (tmp2_1 + 1 | 0)) {
                  tmp_3 = true;
                } else {
                  // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                  // Inline function 'kotlinx.io.and' call
                  tmp_3 = !((_this__u8e3s4[tmp2_1 + 1 | 0] & 192) === 128);
                }
                if (tmp_3) {
                  tmp$ret$41 = 1;
                  break $l$block_10;
                } else {
                  var tmp_4;
                  if (endIndex <= (tmp2_1 + 2 | 0)) {
                    tmp_4 = true;
                  } else {
                    // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                    // Inline function 'kotlinx.io.and' call
                    tmp_4 = !((_this__u8e3s4[tmp2_1 + 2 | 0] & 192) === 128);
                  }
                  if (tmp_4) {
                    tmp$ret$41 = 2;
                    break $l$block_10;
                  } else {
                    tmp$ret$41 = 3;
                    break $l$block_10;
                  }
                }
              }
              var b0_2 = _this__u8e3s4[tmp2_1];
              var b1_1 = _this__u8e3s4[tmp2_1 + 1 | 0];
              // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
              // Inline function 'kotlinx.io.and' call
              if (!((b1_1 & 192) === 128)) {
                if (!(65533 === 65533)) {
                  var c_14 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_15 = length;
                  length = _unary__edvuaz_15 + 1 | 0;
                  chars[_unary__edvuaz_15] = c_14;
                  var c_15 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_16 = length;
                  length = _unary__edvuaz_16 + 1 | 0;
                  chars[_unary__edvuaz_16] = c_15;
                } else {
                  var c_16 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_17 = length;
                  length = _unary__edvuaz_17 + 1 | 0;
                  chars[_unary__edvuaz_17] = c_16;
                }
                tmp$ret$41 = 1;
                break $l$block_10;
              }
              var b2_0 = _this__u8e3s4[tmp2_1 + 2 | 0];
              // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
              // Inline function 'kotlinx.io.and' call
              if (!((b2_0 & 192) === 128)) {
                if (!(65533 === 65533)) {
                  var c_17 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_18 = length;
                  length = _unary__edvuaz_18 + 1 | 0;
                  chars[_unary__edvuaz_18] = c_17;
                  var c_18 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_19 = length;
                  length = _unary__edvuaz_19 + 1 | 0;
                  chars[_unary__edvuaz_19] = c_18;
                } else {
                  var c_19 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_20 = length;
                  length = _unary__edvuaz_20 + 1 | 0;
                  chars[_unary__edvuaz_20] = c_19;
                }
                tmp$ret$41 = 2;
                break $l$block_10;
              }
              var b3 = _this__u8e3s4[tmp2_1 + 3 | 0];
              // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
              // Inline function 'kotlinx.io.and' call
              if (!((b3 & 192) === 128)) {
                if (!(65533 === 65533)) {
                  var c_20 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_21 = length;
                  length = _unary__edvuaz_21 + 1 | 0;
                  chars[_unary__edvuaz_21] = c_20;
                  var c_21 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_22 = length;
                  length = _unary__edvuaz_22 + 1 | 0;
                  chars[_unary__edvuaz_22] = c_21;
                } else {
                  var c_22 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_23 = length;
                  length = _unary__edvuaz_23 + 1 | 0;
                  chars[_unary__edvuaz_23] = c_22;
                }
                tmp$ret$41 = 3;
                break $l$block_10;
              }
              var codePoint_1 = 3678080 ^ b3 ^ b2_0 << 6 ^ b1_1 << 12 ^ b0_2 << 18;
              if (codePoint_1 > 1114111) {
                if (!(65533 === 65533)) {
                  var c_23 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_24 = length;
                  length = _unary__edvuaz_24 + 1 | 0;
                  chars[_unary__edvuaz_24] = c_23;
                  var c_24 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_25 = length;
                  length = _unary__edvuaz_25 + 1 | 0;
                  chars[_unary__edvuaz_25] = c_24;
                } else {
                  var c_25 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_26 = length;
                  length = _unary__edvuaz_26 + 1 | 0;
                  chars[_unary__edvuaz_26] = c_25;
                }
              } else if (55296 <= codePoint_1 ? codePoint_1 <= 57343 : false) {
                if (!(65533 === 65533)) {
                  var c_26 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_27 = length;
                  length = _unary__edvuaz_27 + 1 | 0;
                  chars[_unary__edvuaz_27] = c_26;
                  var c_27 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_28 = length;
                  length = _unary__edvuaz_28 + 1 | 0;
                  chars[_unary__edvuaz_28] = c_27;
                } else {
                  var c_28 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_29 = length;
                  length = _unary__edvuaz_29 + 1 | 0;
                  chars[_unary__edvuaz_29] = c_28;
                }
              } else if (codePoint_1 < 65536) {
                if (!(65533 === 65533)) {
                  var c_29 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_30 = length;
                  length = _unary__edvuaz_30 + 1 | 0;
                  chars[_unary__edvuaz_30] = c_29;
                  var c_30 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_31 = length;
                  length = _unary__edvuaz_31 + 1 | 0;
                  chars[_unary__edvuaz_31] = c_30;
                } else {
                  var c_31 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_32 = length;
                  length = _unary__edvuaz_32 + 1 | 0;
                  chars[_unary__edvuaz_32] = c_31;
                }
              } else {
                if (!(codePoint_1 === 65533)) {
                  var c_32 = numberToChar((codePoint_1 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_33 = length;
                  length = _unary__edvuaz_33 + 1 | 0;
                  chars[_unary__edvuaz_33] = c_32;
                  var c_33 = numberToChar((codePoint_1 & 1023) + 56320 | 0);
                  var _unary__edvuaz_34 = length;
                  length = _unary__edvuaz_34 + 1 | 0;
                  chars[_unary__edvuaz_34] = c_33;
                } else {
                  var c_34 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_35 = length;
                  length = _unary__edvuaz_35 + 1 | 0;
                  chars[_unary__edvuaz_35] = c_34;
                }
              }
              tmp$ret$41 = 4;
            }
            index = tmp_2 + tmp$ret$41 | 0;
          } else {
            var c_35 = _Char___init__impl__6a9atx(65533);
            var _unary__edvuaz_36 = length;
            length = _unary__edvuaz_36 + 1 | 0;
            chars[_unary__edvuaz_36] = c_35;
            index = index + 1 | 0;
          }
        }
      }
    }
  }
  return concatToString(chars, 0, length);
}
function get_SegmentReadContextImpl() {
  _init_properties_UnsafeBufferOperations_kt__xw75gy();
  return SegmentReadContextImpl;
}
var SegmentReadContextImpl;
function get_SegmentWriteContextImpl() {
  _init_properties_UnsafeBufferOperations_kt__xw75gy();
  return SegmentWriteContextImpl;
}
var SegmentWriteContextImpl;
var BufferIterationContextImpl;
function UnsafeBufferOperations() {
}
var UnsafeBufferOperations_instance;
function UnsafeBufferOperations_getInstance() {
  return UnsafeBufferOperations_instance;
}
function SegmentReadContextImpl$1() {
}
protoOf(SegmentReadContextImpl$1).r1v = function (segment, offset) {
  return segment.r1u(offset);
};
function SegmentWriteContextImpl$1() {
}
protoOf(SegmentWriteContextImpl$1).r1w = function (segment, offset, value) {
  segment.k1w(offset, value);
};
protoOf(SegmentWriteContextImpl$1).q1w = function (segment, offset, b0, b1) {
  segment.l1w(offset, b0, b1);
};
protoOf(SegmentWriteContextImpl$1).p1w = function (segment, offset, b0, b1, b2) {
  segment.m1w(offset, b0, b1, b2);
};
protoOf(SegmentWriteContextImpl$1).o1w = function (segment, offset, b0, b1, b2, b3) {
  segment.n1w(offset, b0, b1, b2, b3);
};
function BufferIterationContextImpl$1() {
}
protoOf(BufferIterationContextImpl$1).r1v = function (segment, offset) {
  return get_SegmentReadContextImpl().r1v(segment, offset);
};
var properties_initialized_UnsafeBufferOperations_kt_2xfgoc;
function _init_properties_UnsafeBufferOperations_kt__xw75gy() {
  if (!properties_initialized_UnsafeBufferOperations_kt_2xfgoc) {
    properties_initialized_UnsafeBufferOperations_kt_2xfgoc = true;
    SegmentReadContextImpl = new SegmentReadContextImpl$1();
    SegmentWriteContextImpl = new SegmentWriteContextImpl$1();
    BufferIterationContextImpl = new BufferIterationContextImpl$1();
  }
}
function IOException_init_$Init$($this) {
  Exception_init_$Init$($this);
  IOException.call($this);
  return $this;
}
function IOException_init_$Create$() {
  var tmp = IOException_init_$Init$(objectCreate(protoOf(IOException)));
  captureStack(tmp, IOException_init_$Create$);
  return tmp;
}
function IOException_init_$Init$_0(message, $this) {
  Exception_init_$Init$_0(message, $this);
  IOException.call($this);
  return $this;
}
function IOException_init_$Create$_0(message) {
  var tmp = IOException_init_$Init$_0(message, objectCreate(protoOf(IOException)));
  captureStack(tmp, IOException_init_$Create$_0);
  return tmp;
}
function IOException_init_$Init$_1(message, cause, $this) {
  Exception_init_$Init$_1(message, cause, $this);
  IOException.call($this);
  return $this;
}
function IOException_init_$Create$_1(message, cause) {
  var tmp = IOException_init_$Init$_1(message, cause, objectCreate(protoOf(IOException)));
  captureStack(tmp, IOException_init_$Create$_1);
  return tmp;
}
function IOException() {
  captureStack(this, IOException);
}
function EOFException_init_$Init$($this) {
  IOException_init_$Init$($this);
  EOFException.call($this);
  return $this;
}
function EOFException_init_$Create$() {
  var tmp = EOFException_init_$Init$(objectCreate(protoOf(EOFException)));
  captureStack(tmp, EOFException_init_$Create$);
  return tmp;
}
function EOFException_init_$Init$_0(message, $this) {
  IOException_init_$Init$_0(message, $this);
  EOFException.call($this);
  return $this;
}
function EOFException_init_$Create$_0(message) {
  var tmp = EOFException_init_$Init$_0(message, objectCreate(protoOf(EOFException)));
  captureStack(tmp, EOFException_init_$Create$_0);
  return tmp;
}
function EOFException() {
  captureStack(this, EOFException);
}
function SegmentPool() {
  this.b1v_1 = 0;
  this.c1v_1 = 0;
}
protoOf(SegmentPool).d1v = function () {
  return Companion_instance.f1w();
};
protoOf(SegmentPool).s1v = function (segment) {
};
protoOf(SegmentPool).h1w = function () {
  return AlwaysSharedCopyTracker_getInstance();
};
var SegmentPool_instance;
function SegmentPool_getInstance() {
  return SegmentPool_instance;
}
//region block: post-declaration
protoOf(Buffer).h1v = write$default;
//endregion
//region block: init
Companion_instance = new Companion();
UnsafeBufferOperations_instance = new UnsafeBufferOperations();
SegmentPool_instance = new SegmentPool();
//endregion
//region block: exports
export {
  EOFException_init_$Create$_0 as EOFException_init_$Create$2ki37nn86l2yt,
  IOException_init_$Init$_0 as IOException_init_$Init$3tijvyh8jladu,
  IOException_init_$Create$_0 as IOException_init_$Create$1wkk79fgwuoz2,
  IOException_init_$Init$_1 as IOException_init_$Init$1s6rw4r2mxxsm,
  IOException_init_$Create$_1 as IOException_init_$Create$2jyze3554lamk,
  Buffer as Buffergs925ekssbch,
  IOException as IOException1wyutdmfe71nu,
  Source as Source1shr0ps16u4p4,
  indexOf_1 as indexOf29nspdgx2e3ap,
  readByteArray_0 as readByteArray1fhzfwi2j014k,
  readByteArray as readByteArray1ri21h2rciakw,
  readByteString as readByteString2hnsbql6t4ads,
  readString_0 as readString2nvggcfaijfhd,
  readString_1 as readString3v6duspiz33tv,
  readString as readStringo8i62qxt5m4m,
  writeString as writeString33ca4btrgctw7,
};
//endregion

//# sourceMappingURL=kotlinx-io-kotlinx-io-core.mjs.map
